var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

function NewsToolbar(el) {
  var $el = $(el),
      $select = $el.find('.custom-select'),
      $unfilter = $el.find('.clear-filter');

  // Toggle toolbar panels (mobile)
  $el.find('.news-toolbar__toggle').on('click', function(e) {
    e.preventDefault();
    $(this).next().show();
  });

  $el.find('.close-button').on('click', function(e) {
    e.preventDefault();
    $(this).closest('.news-toolbar__section').hide();
  });

  // Hide filter dropdown options when user clicks outside dropdown
  $(document).click(function(){
    $select.children('ul').hide();
  });

  // Clicks within the dropdown won't bubble up past the dropdown element
  $('.custom-select').click(function(e){
    e.stopPropagation();
  });

  $select.on('click', 'p', function() {
    // Expand dropdown options
    $select.children('ul').hide();
    $(this).next().show();
  }).on('click', 'a', function(e) {
    e.preventDefault();
    // When an option is selected, change the selected value
    var $dropdown = $(this).closest('.custom-select'),
        $dropdownLabel = $dropdown.find('p'),
        $dropdownClear = $dropdown.prev().find('.clear-filter');
    $dropdownLabel.attr('data-val', $(this).attr('data-val')).text($(this).text());
    $dropdown.children('ul').hide();
    if ($dropdownLabel.attr('data-val') === '') {
      $dropdownClear.hide();
    } else {
      $dropdownClear.show();
    }
    window.location = window.location.origin + $(this).attr('href');
  });

  $unfilter.on('click', function(e) {
    e.preventDefault();
    $(this).hide();
    $dropdown = $(this).parent().next();
    $dropdown.find('p').attr('data-val', '').text($dropdown.find('li:first-child').text());
    window.location = window.location.origin + '/news';
  });
}

module.exports = NewsToolbar;
